export const initNavi = (): void => {
    const btnOpen  = document.querySelector<HTMLButtonElement>('#spmenuOpen');
    const btnClose = document.querySelector<HTMLButtonElement>('#spmenuClose');
    const menu     = document.querySelector<HTMLElement>('#spmenu');

    if (!btnOpen || !btnClose || !menu) return;

    // ── サブメニュー ──────────────────────────
    const subMenuTriggers = document.querySelectorAll<HTMLElement>('#spmenu .js-subMenuTrigger, .l-header-2-pc .js-subMenuTrigger');
    const BP = 1300;

    const cacheSpHeights = () => {
        subMenuTriggers.forEach((trigger) => {
            const target = trigger.dataset.target;
            if (!target) return;
            const subContent = document.querySelector<HTMLElement>(`#spmenu .l-navi-sub-sp[data-target="${target}"]`);
            if (!subContent) return;
            subContent.style.maxHeight = 'none';
            subContent.dataset.height = `${subContent.scrollHeight}`;
            subContent.style.maxHeight = subContent.classList.contains('is-show')
                ? `${subContent.dataset.height}px`
                : '0';
        });
    };

    const toggleMenu = (): void => {
        menu.classList.toggle('is-show');
        if (menu.classList.contains('is-show')) {
            menu.addEventListener('transitionend', cacheSpHeights, { once: true });
        }
    };

    btnOpen.addEventListener('click', toggleMenu);
    btnClose.addEventListener('click', toggleMenu);

    menu.addEventListener('click', (e: Event) => {
        const target = e.target as HTMLElement;
        if (target.closest('a')) {
            toggleMenu();
        }
    });

    if (!subMenuTriggers.length) return;

    const getSubContent = (target: string) => {
        if (window.innerWidth >= BP) {
            return document.querySelector<HTMLElement>(`.l-navi-sub-pc[data-target="${target}"]`);
        } else {
            return document.querySelector<HTMLElement>(`#spmenu .l-navi-sub-sp[data-target="${target}"]`);
        }
    };

    const closeContent = (trigger: HTMLElement, content: HTMLElement) => {
        trigger.classList.remove('is-show');
        content.classList.remove('is-show');
        if (window.innerWidth < BP) {
            content.style.maxHeight = '0';
        }
    };

    const openContent = (trigger: HTMLElement, content: HTMLElement) => {
        trigger.classList.add('is-show');
        content.classList.add('is-show');
        if (window.innerWidth < BP) {
            const height = content.dataset.height ?? `${content.scrollHeight}`;
            content.style.maxHeight = `${height}px`;
        }
    };

    subMenuTriggers.forEach((trigger) => {
        const target = trigger.dataset.target;
        if (!target) return;

        trigger.addEventListener('click', () => {
            const subContent = getSubContent(target);
            if (!subContent) return;

            const isOpen = subContent.classList.contains('is-show');

            subMenuTriggers.forEach((otherTrigger) => {
                if (otherTrigger === trigger) return;
                const otherTarget = otherTrigger.dataset.target;
                if (!otherTarget) return;
                const otherContent = getSubContent(otherTarget);
                if (!otherContent) return;
                closeContent(otherTrigger, otherContent);
            });

            isOpen ? closeContent(trigger, subContent) : openContent(trigger, subContent);
        });
    });

    window.addEventListener('resize', () => {
        subMenuTriggers.forEach((trigger) => {
            const target = trigger.dataset.target;
            if (!target) return;
            const subContent = getSubContent(target);
            if (!subContent) return;

            if (window.innerWidth >= BP) {
                subContent.style.maxHeight = '';
            } else {
                if (subContent.classList.contains('is-show')) {
                    subContent.style.maxHeight = `${subContent.scrollHeight}px`;
                }
            }
        });
    });
};